// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__THHe5","hasBackground":"Icon_hasBackground__03DDI"};